export default __webpack_public_path__ + "static/media/apple-music.5b192549.svg";